const FulFillmentState = Object.freeze({
    FULFILLED: 'fulfilled',
    PART_FULFILLED: 'partfulfilled',
    UNFULFILLED: 'unfulfilled',
});

module.exports = FulFillmentState;
